var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VerifyIdentityError',{staticClass:"md:w-480 md:mx-auto",attrs:{"errorTitle":_vm.$t('common.no_contact_info_found'),"errorBody":_vm.coalescedSupportText('common.contact_health_plan_csr.help'),"cancelText":_vm.$t('common.return_to_login')},on:{"cancel":_vm.handleReturn}})
}
var staticRenderFns = []

export { render, staticRenderFns }